/* Dashboard Store */

import {
  fetchActionItems,
  fetchSalesPipeline,
  fetchPastDueAtRisk,
  fetchCustomerContacts,
  fetchBillingAndSales,
  fetchOffToday,
  fetchHotOrders,
  fetchPastDueByOffice,
  fetchDropShips,
  fetchCreditHolds,
  fetchQuote,
  fetchBackgroundImage
} from '@/api'

const state = {
  actionItems: {
    count: 0,
    items: []
  },
  salesPipeline: {
    count: 0,
    items: []
  },
  pastDueAtRisk: {
    count: 0
  },
  customerContacts: {
    count: 0
  },
  billingAndSales: {
    salesMTD: 0,
    billingMTD: 0,
    salesToday: 0,
    backlog: 0,
    backlogFormatted: 0,
    salesMTDFormatted: 0,
    billingMTDFormatted: 0,
    salesTodayFormatted: 0
  },
  offToday: {
    count: 0,
    users: []
  },
  hotOrders: {
    count: 0,
    orders: []
  },
  pastDueByOffice: {
    count: 0
  },
  dropShips: {
    count: 0
  },
  creditHolds: {
    count: 0,
    holds: []
  },
  quote: {
    author: '',
    text: ''
  },
  backgroundImage: {
    url: '',
    title: '',
    username: '',
    name: ''
  }
}

const actions = {
  /* Fetch action items for the dashboard. */
  fetchActionItems (context) {
    return fetchActionItems().then((response) => {
      context.commit('setActionItems', response.data)
    })
  },

  /* Fetch sales pipeline. */
  fetchSalesPipeline (context) {
    return fetchSalesPipeline().then((response) => {
      context.commit('setSalesPipeline', response.data)
    })
  },

  /* Fetch past-due/at-risk orders */
  fetchPastDueAtRisk (context) {
    return fetchPastDueAtRisk().then((response) => {
      context.commit('setPastDueAtRisk', response.data)
    })
  },

  /* Fetch Customer Contacts for the dashboard. */
  fetchCustomerContacts (context) {
    return fetchCustomerContacts().then((response) => {
      context.commit('setCustomerContacts', response.data)
    })
  },

  /* Fetch billing and sales data for the dashboard. */
  fetchBillingAndSales (context) {
    return fetchBillingAndSales().then((response) => {
      context.commit('setBillingAndSales', response.data)
    })
  },

  /* Fetch users who are off today for the dashboard */
  fetchOffToday (context) {
    return fetchOffToday().then((response) => {
      context.commit('setOffToday', response.data)
    })
  },

  /* Fetch hot orders for the dashboard. */
  fetchHotOrders (context) {
    return fetchHotOrders().then((response) => {
      context.commit('setHotOrders', response.data)
    })
  },

  /* Fetch Past Due Orders for the dashboard */
  fetchPastDueByOffice (context) {
    return fetchPastDueByOffice().then((response) => {
      context.commit('setPastDueByOffice', response.data)
    })
  },

  /* Fetch dropships for the dashboard. */
  fetchDropShips (context) {
    return fetchDropShips().then((response) => {
      context.commit('setDropShips', response.data)
    })
  },

  /* Look up credit holds for the dashboard */
  fetchCreditHolds (context) {
    fetchCreditHolds().then((response) => {
      context.commit('setCreditHolds', response.data)
    })
  },

  /* Fetch a quote for the dashboard. */
  fetchQuote (context) {
    fetchQuote().then((response) => {
      context.commit('setQuote', response.data)
    })
  },

  /* Fetch a background image for the dashboard. */
  fetchBackgroundImage (context) {
    return fetchBackgroundImage().then((response) => {
      return context.commit('setBackgroundImage', response.data)
    })
  }
}

const mutations = {
  setActionItems (state, payload) {
    state.actionItems = payload
  },
  setSalesPipeline (state, payload) {
    state.salesPipeline = payload
  },
  setPastDueAtRisk (state, payload) {
    state.pastDueAtRisk = payload
  },
  setCustomerContacts (state, payload) {
    state.customerContacts = payload
  },
  setBillingAndSales (state, payload) {
    state.billingAndSales = payload
  },
  setOffToday (state, payload) {
    state.offToday = payload
  },
  setHotOrders (state, payload) {
    state.hotOrders = payload
  },
  setPastDueByOffice (state, payload) {
    state.pastDueByOffice = payload
  },
  setDropShips (state, payload) {
    state.dropShips = payload
  },
  setCreditHolds (state, payload) {
    state.creditHolds = payload
  },
  setQuote (state, payload) {
    state.quote = payload
  },
  setBackgroundImage (state, payload) {
    state.backgroundImage = payload
  }
}

const getters = {
  getActionItems (state) {
    return state.actionItems
  },
  getSalesPipeline (state) {
    return state.salesPipeline
  },
  getPastDueAtRisk (state) {
    return state.pastDueAtRisk
  },
  getCustomerContacts (state) {
    return state.customerContacts
  },
  getBillingAndSales (state) {
    return state.billingAndSales
  },
  getOffToday (state) {
    return state.offToday
  },
  getHotOrders (state) {
    return state.hotOrders
  },
  getPastDueByOffice (state) {
    return state.pastDueByOffice
  },
  getDropShips (state) {
    return state.dropShips
  },
  getCreditHolds (state) {
    return state.creditHolds
  },
  getQuote (state) {
    return state.quote
  },
  getBackgroundImage (state) {
    return state.backgroundImage
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
